import { useCallback, useEffect, useState } from "react";
import { RecentSearchItem } from "../types";
import {
    addRecentSearch,
    clearStoredRecentSearches,
    readRecentSearches,
    RECENT_SEARCHES_STORAGE_KEY,
    RECENT_SEARCHES_SYNC_EVENT,
    writeRecentSearches,
} from "../util/recentSearches";

// // // //

function dispatchRecentSearchesSyncEvent() {
    if (typeof window === "undefined") {
        return;
    }

    window.dispatchEvent(new Event(RECENT_SEARCHES_SYNC_EVENT));
}

export function useRecentSearches() {
    const [recentSearches, setRecentSearches] = useState<RecentSearchItem[]>(
        [],
    );

    useEffect(() => {
        setRecentSearches(readRecentSearches());

        if (typeof window === "undefined") {
            return;
        }

        const syncRecentSearches = () => {
            setRecentSearches(readRecentSearches());
        };

        const handleStorage = (event: StorageEvent) => {
            if (event.key && event.key !== RECENT_SEARCHES_STORAGE_KEY) {
                return;
            }

            syncRecentSearches();
        };

        window.addEventListener(RECENT_SEARCHES_SYNC_EVENT, syncRecentSearches);
        window.addEventListener("storage", handleStorage);

        return () => {
            window.removeEventListener(
                RECENT_SEARCHES_SYNC_EVENT,
                syncRecentSearches,
            );
            window.removeEventListener("storage", handleStorage);
        };
    }, []);

    const addItem = useCallback((item: RecentSearchItem) => {
        const nextSearches = addRecentSearch(readRecentSearches(), item);
        writeRecentSearches(nextSearches);
        setRecentSearches(nextSearches);
        dispatchRecentSearchesSyncEvent();
    }, []);

    const clearItems = useCallback(() => {
        clearStoredRecentSearches();
        setRecentSearches([]);
        dispatchRecentSearchesSyncEvent();
    }, []);

    return {
        recentSearches,
        addRecentSearch: addItem,
        clearRecentSearches: clearItems,
    };
}
